export function removeFalsyValuesFromFilters<T extends Record<string, any>>(
  obj: T
): Partial<T> {
  const res = Object.entries(obj).filter(([_, value]) => value);
  return Object.fromEntries(res) as Partial<T>;
}
